 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import OEBPSTEXTPRAISE_FOR_DAVID_P_WAGNER from '@/components/OEBPS/Text/Praise_for_David_P._Wagner'
 import OEBPSTEXTTITLE_PAGE from '@/components/OEBPS/Text/Title_Page'
 import OEBPSTEXTCOPYRIGHT from '@/components/OEBPS/Text/Copyright'
 import OEBPSTEXTCONTENTS from '@/components/OEBPS/Text/Contents'
 import OEBPSTEXTDEDICATION from '@/components/OEBPS/Text/Dedication'
 import OEBPSTEXTCHAPTER_1 from '@/components/OEBPS/Text/Chapter_1'
 import OEBPSTEXTCHAPTER_2 from '@/components/OEBPS/Text/Chapter_2'
 import OEBPSTEXTCHAPTER_3 from '@/components/OEBPS/Text/Chapter_3'
 import OEBPSTEXTCHAPTER_4 from '@/components/OEBPS/Text/Chapter_4'
 import OEBPSTEXTCHAPTER_5 from '@/components/OEBPS/Text/Chapter_5'
 import OEBPSTEXTCHAPTER_6 from '@/components/OEBPS/Text/Chapter_6'
 import OEBPSTEXTCHAPTER_7 from '@/components/OEBPS/Text/Chapter_7'
 import OEBPSTEXTCHAPTER_8 from '@/components/OEBPS/Text/Chapter_8'
 import OEBPSTEXTCHAPTER_9 from '@/components/OEBPS/Text/Chapter_9'
 import OEBPSTEXTCHAPTER_10 from '@/components/OEBPS/Text/Chapter_10'
 import OEBPSTEXTCHAPTER_11 from '@/components/OEBPS/Text/Chapter_11'
 import OEBPSTEXTCHAPTER_12 from '@/components/OEBPS/Text/Chapter_12'
 import OEBPSTEXTCHAPTER_13 from '@/components/OEBPS/Text/Chapter_13'
 import OEBPSTEXTCHAPTER_14 from '@/components/OEBPS/Text/Chapter_14'
 import OEBPSTEXTCHAPTER_15 from '@/components/OEBPS/Text/Chapter_15'
 import OEBPSTEXTTHE_WINE from '@/components/OEBPS/Text/The_Wine'
 import LOVE_2 from '@/components/love_2'
 import OEBPSTEXTAUTHORS_NOTE from '@/components/OEBPS/Text/Authors_Note'
 import OEBPSTEXTMORE_FROM_THIS_AUTHOR from '@/components/OEBPS/Text/More_from_this_Author'
 import OEBPSTEXTCONTACT_US from '@/components/OEBPS/Text/Contact_Us'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/Text/Contents",
 			"name" : "OEBPS/Text/Contents",
 			"component" : OEBPSTEXTCONTENTS
 		},
 		{
 			"path" : "/OEBPS/Text/Dedication",
 			"name" : "OEBPS/Text/Dedication",
 			"component" : OEBPSTEXTDEDICATION
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_1",
 			"name" : "OEBPS/Text/Chapter_1",
 			"component" : OEBPSTEXTCHAPTER_1
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_2",
 			"name" : "OEBPS/Text/Chapter_2",
 			"component" : OEBPSTEXTCHAPTER_2
 		},
 		{
 			"path" : "/OEBPS/Text/Chapter_3",
 			"name" : "OEBPS/Text/Chapter_3",
 			"component" : OEBPSTEXTCHAPTER_3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js